/** Pure navigation / zoom helpers for the deck viewer. */

/** Extract a share id from /view/{share_id}. Accepts a trailing slash only. */
export function parseShareId(pathname: string): string | null {
  const match = /^\/view\/([A-Za-z0-9_-]{1,128})\/?$/.exec(pathname);
  return match ? match[1] : null;
}

export function clampPage(page: number, pageCount: number): number {
  if (!Number.isFinite(page)) return 1;
  return Math.min(Math.max(Math.trunc(page), 1), Math.max(pageCount, 1));
}

export function nextPage(page: number, pageCount: number): number {
  return clampPage(page + 1, pageCount);
}

export function prevPage(page: number): number {
  if (!Number.isFinite(page)) return 1;
  return Math.max(Math.trunc(page) - 1, 1);
}

/** Discrete zoom factors; 1 means "fit to screen". */
export const ZOOM_STEPS = [1, 1.25, 1.6, 2, 2.5, 3.2] as const;

export const MIN_ZOOM = ZOOM_STEPS[0];
export const MAX_ZOOM = ZOOM_STEPS[ZOOM_STEPS.length - 1];

/** Nearest step when zooming in (+1) or out (-1) from an arbitrary factor. */
export function zoomStep(current: number, direction: 1 | -1): number {
  if (direction === 1) {
    for (const step of ZOOM_STEPS) if (step > current + 0.001) return step;
    return MAX_ZOOM;
  }
  for (let i = ZOOM_STEPS.length - 1; i >= 0; i -= 1) {
    if (ZOOM_STEPS[i] < current - 0.001) return ZOOM_STEPS[i];
  }
  return MIN_ZOOM;
}

export function clampZoom(zoom: number): number {
  if (!Number.isFinite(zoom)) return 1;
  return Math.min(Math.max(zoom, MIN_ZOOM), MAX_ZOOM);
}
